import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { 
  ChevronDown, ChevronUp, Search, HelpCircle, Wrench, 
  Thermometer, Zap, Droplets, Refrigerator, Phone,
  Clock, Shield, CreditCard, MapPin, MessageCircle,
  CheckCircle, AlertTriangle, Info, ArrowRight
} from 'lucide-react';
import { Input } from '../components/ui/input';

const SSS = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [openCategory, setOpenCategory] = useState('genel');
  const [openQuestions, setOpenQuestions] = useState({});

  const toggleQuestion = (id) => {
    setOpenQuestions(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const categories = [
    { id: 'genel', name: 'Genel Sorular', icon: HelpCircle, color: 'from-blue-500 to-indigo-600' },
    { id: 'talep', name: 'Talep Oluşturma', icon: MessageCircle, color: 'from-emerald-500 to-teal-600' },
    { id: 'kombi', name: 'Kombi Servisi', icon: Thermometer, color: 'from-orange-500 to-red-600' },
    { id: 'klima', name: 'Klima Servisi', icon: Wrench, color: 'from-cyan-500 to-blue-600' },
    { id: 'elektrik', name: 'Elektrik Hizmetleri', icon: Zap, color: 'from-yellow-500 to-orange-600' },
    { id: 'beyaz', name: 'Beyaz Eşya', icon: Refrigerator, color: 'from-purple-500 to-pink-600' },
    { id: 'tesisat', name: 'Su Tesisatı', icon: Droplets, color: 'from-sky-500 to-blue-600' },
    { id: 'odeme', name: 'Ödeme & Garanti', icon: CreditCard, color: 'from-green-500 to-emerald-600' },
  ];

  const faqData = {
    genel: [
      {
        id: 'g1',
        question: 'HizmetGeliyo nedir ve nasıl çalışır?',
        answer: 'HizmetGeliyo, ev hizmetleri için Türkiye\'nin en güvenilir platformudur. Kombi, klima, beyaz eşya, elektrik ve su tesisatı gibi alanlarda uzman ustaları müşterilerle buluşturuyoruz. Yapay zeka destekli sistemimiz sayesinde ihtiyacınıza en uygun ustayı 2 dakika içinde bulabilirsiniz.'
      },
      {
        id: 'g2',
        question: 'HizmetGeliyo\'yu kullanmak ücretli mi?',
        answer: 'Hayır, HizmetGeliyo\'yu kullanmak tamamen ücretsizdir. Sadece aldığınız hizmetin ücretini ödersiniz. Talep oluşturma, teklif alma ve usta ile iletişime geçme işlemleri için herhangi bir ücret alınmaz.'
      },
      {
        id: 'g3',
        question: 'Ustalarınız güvenilir mi?',
        answer: 'Evet, platformumuzdaki tüm ustalar kapsamlı bir doğrulama sürecinden geçer. Kimlik kontrolü, mesleki yeterlilik belgesi kontrolü ve referans araştırması yapılır. Ayrıca tüm ustalarımız garanti kapsamında hizmet verir.'
      },
      {
        id: 'g4',
        question: 'Hangi şehirlerde hizmet veriyorsunuz?',
        answer: 'Şu anda Türkiye\'nin 81 ilinde hizmet vermekteyiz. Her ilçede onaylı ustalarımız bulunmaktadır. Talep oluşturduğunuzda size en yakın ustalar otomatik olarak bilgilendirilir.'
      },
      {
        id: 'g5',
        question: 'Acil durumlarda ne yapmalıyım?',
        answer: '7/24 acil servis hizmetimiz mevcuttur. Talep oluştururken "Acil" seçeneğini işaretleyerek öncelikli hizmet alabilirsiniz. Ayrıca destek hattımız 0850 242 78 08 numarasından bize ulaşabilirsiniz.'
      },
    ],
    talep: [
      {
        id: 't1',
        question: 'Nasıl talep oluşturabilirim?',
        answer: 'Talep oluşturmak çok kolay! Ana sayfadan hizmet kategorisini seçin (kombi, klima, elektrik vb.), sorularımızı cevaplayın, adres ve iletişim bilgilerinizi girin. Yapay zeka asistanımız size fiyat tahmini verecek ve en uygun ustayı önerecektir.'
      },
      {
        id: 't2',
        question: 'Talep oluşturduktan sonra ne olur?',
        answer: '1. Talebiniz sistemimize kaydedilir\n2. Bölgenizdeki uygun ustalar bilgilendirilir\n3. En uygun usta size atanır\n4. Usta sizinle telefon ile iletişime geçer\n5. Randevu saati belirlenir\n6. Usta gelir ve işi tamamlar\n7. Ödemenizi yaparsınız'
      },
      {
        id: 't3',
        question: 'Talebimi iptal edebilir miyim?',
        answer: 'Evet, usta atanmadan önce talebinizi ücretsiz iptal edebilirsiniz. Usta atandıktan sonra iptal için lütfen destek hattımızı arayın. Ustanın yola çıkmasından sonra yapılan iptallerde yol masrafı alınabilir.'
      },
      {
        id: 't4',
        question: 'Fotoğraf eklemek zorunlu mu?',
        answer: 'Fotoğraf eklemek zorunlu değildir ancak şiddetle tavsiye edilir. Arızanın fotoğrafını paylaşmanız ustanın sorunu daha iyi anlamasını ve doğru ekipmanla gelmesini sağlar. Bu sayede işlem süresi kısalır.'
      },
      {
        id: 't5',
        question: 'Tahmini fiyat ne kadar doğru?',
        answer: 'Yapay zeka destekli fiyat tahminimiz %85-90 oranında doğrudur. Ancak kesin fiyat, ustanın arızayı yerinde görmesiyle belirlenir. Parça değişimi gerekirse ek ücret söz konusu olabilir. Usta her durumda işe başlamadan önce size bilgi verir.'
      },
      {
        id: 't6',
        question: 'Birden fazla hizmet için aynı anda talep oluşturabilir miyim?',
        answer: 'Evet, her hizmet kategorisi için ayrı ayrı talep oluşturabilirsiniz. Aynı kategoride birden fazla sorun varsa (örneğin 2 klima bakımı) bunu talep notlarına yazabilirsiniz.'
      },
    ],
    kombi: [
      {
        id: 'k1',
        question: 'Kombim neden su ısıtmıyor?',
        answer: 'Kombinin su ısıtmamasının birçok nedeni olabilir:\n• Gaz kesintisi veya gaz vanası kapalı olabilir\n• Devirdaim pompası arızalı olabilir\n• Eşanjör kireçli olabilir\n• Ateşleme sistemi bozulmuş olabilir\n• Termokupl veya iyonizasyon sensörü arızalı olabilir\n\nBu sorunlar profesyonel müdahale gerektirir. Kendiniz müdahale etmeyiniz.'
      },
      {
        id: 'k2',
        question: 'Kombi kaç yılda bir bakım yaptırmalıyım?',
        answer: 'Kombi bakımı YILDA EN AZ 1 KEZ yaptırılmalıdır. Kış sezonu öncesi (Eylül-Ekim ayları) ideal bakım zamanıdır. Düzenli bakım:\n• Kombinin ömrünü uzatır\n• %20-30 yakıt tasarrufu sağlar\n• Arıza riskini minimize eder\n• Can güvenliğinizi sağlar\n• Garanti sürekliliğini korur'
      },
      {
        id: 'k3',
        question: 'Kombiden garip sesler geliyor, ne yapmalıyım?',
        answer: 'Kombiden gelen sesler önemli bir arıza habercisi olabilir:\n• Fokurdama sesi: Sistemde hava olabilir\n• Tıkırtı sesi: Genleşme boruları sorunlu olabilir\n• Uğultu sesi: Pompa veya fan sorunu olabilir\n• Patlama sesi: Ateşleme gecikmesi olabilir (ACİL)\n\nÖzellikle patlama sesi duyarsanız hemen kombiyi kapatıp uzman çağırın.'
      },
      {
        id: 'k4',
        question: 'Kombi arıza kodları ne anlama geliyor?',
        answer: 'Her kombi markasının kendine özgü arıza kodları vardır. En yaygın kodlar:\n• E01/F01: Ateşleme hatası\n• E02/F02: Aşırı ısınma\n• E03/F03: Baca veya fan sorunu\n• E10: Düşük su basıncı\n• E25: Sirkülasyon sorunu\n\nArıza kodu aldığınızda notu alıp talep oluştururken belirtin.'
      },
      {
        id: 'k5',
        question: 'Kombi su basıncı ne olmalı?',
        answer: 'Normal kombi su basıncı 1.0 - 1.5 bar arasında olmalıdır. 0.5 bar altı çok düşük, 2.5 bar üstü ise çok yüksektir. Basınç düşükse sistemden su kaçağı olabilir veya genleşme tankı arızalı olabilir. Sürekli basınç kaybı yaşıyorsanız mutlaka servis çağırın.'
      },
      {
        id: 'k6',
        question: 'Hangi kombi markaları için servis veriyorsunuz?',
        answer: 'Tüm kombi markaları için hizmet vermekteyiz:\n• Vaillant, Bosch, Buderus\n• Baymak, DemirDöküm, Alarko\n• Ariston, Ferroli, Protherm\n• Viessmann, Eca, İmmergas\n• Ve diğer tüm markalar...\n\nOrijinal yedek parça garantisi ile çalışıyoruz.'
      },
    ],
    klima: [
      {
        id: 'kl1',
        question: 'Klima neden soğutmuyor?',
        answer: 'Klimanın soğutmama sebepleri:\n• Gaz azalması veya kaçağı\n• Filtreler tıkalı olabilir\n• Dış ünite fan arızası\n• Kompresör sorunu\n• Termostat arızası\n• Dış ünite çok kirli olabilir\n\nÖnce filtreleri kontrol edin, temizse profesyonel servis gerekir.'
      },
      {
        id: 'kl2',
        question: 'Klima bakımı ne sıklıkla yapılmalı?',
        answer: 'Klima bakımı yılda EN AZ 2 KEZ yapılmalıdır:\n• Yaz sezonu öncesi (Nisan-Mayıs)\n• Kış sezonu öncesi (Ekim-Kasım) - ısıtma için kullanılıyorsa\n\nYoğun kullanılan klimalar için 3 aylık bakım önerilir. Filtre temizliği ise ayda 1 kez yapılmalıdır.'
      },
      {
        id: 'kl3',
        question: 'Klima montajı ne kadar sürer?',
        answer: 'Standart klima montajı 2-4 saat sürer. Süreyi etkileyen faktörler:\n• Dış ünite montaj yeri\n• Boru mesafesi\n• Duvar tipi (beton, tuğla)\n• Kat yüksekliği\n• Elektrik altyapısı\n\nMontaj öncesi ustamız keşif yapar ve süre hakkında bilgi verir.'
      },
      {
        id: 'kl4',
        question: 'Klimadan su damlıyor, ne yapmalıyım?',
        answer: 'Klimadan su damlaması yaygın bir sorundur:\n• İç üniteden: Drenaj borusu tıkalı veya eğimi yanlış\n• Dış üniteden: Normal kondensasyon (yaz aylarında)\n• Aşırı su: Gaz azalması işareti olabilir\n\nİç üniteden damlama mutlaka tamir edilmelidir, nem ve küf sorunlarına yol açar.'
      },
      {
        id: 'kl5',
        question: 'Klima gazı ne sıklıkla doldurulmalı?',
        answer: 'Normal şartlarda klima gazı DOLDURMAK GEREKMEMELİDİR. Kapalı bir sistem olan klimada gaz azalması, sistemde kaçak olduğu anlamına gelir. Gaz dolumu yaptırırken mutlaka kaçak tespiti de yaptırın, yoksa gaz tekrar azalır.'
      },
      {
        id: 'kl6',
        question: 'Inverter klima ile normal klima farkı nedir?',
        answer: 'Inverter klimalar:\n• %40-50 daha az elektrik tüketir\n• Daha sessiz çalışır\n• Sabit sıcaklık sağlar\n• Daha uzun ömürlüdür\n• İlk maliyeti daha yüksektir\n\nNormal klimalar:\n• İlk maliyeti düşük\n• Tamir maliyeti düşük\n• Sürekli aç-kapa yapar\n• Daha fazla elektrik tüketir'
      },
    ],
    elektrik: [
      {
        id: 'e1',
        question: 'Sigortalar sürekli atıyor, ne yapmalıyım?',
        answer: 'Sürekli sigorta atması ciddi bir uyarıdır:\n• Aşırı yüklenme olabilir\n• Kısa devre olabilir\n• Kaçak akım olabilir\n• Cihazlardan biri arızalı olabilir\n• Sigorta kapasitesi yetersiz olabilir\n\nBU DURUMDA KENDİNİZ MÜDAHALE ETMEYİN, elektrik ustası çağırın.'
      },
      {
        id: 'e2',
        question: 'Evde kısmi elektrik kesintisi var, ne olabilir?',
        answer: 'Evin bir kısmında elektrik yoksa:\n• O bölümün sigortası atmış olabilir\n• Nötr hattı kopmuş olabilir (TEHLİKELİ)\n• Bağlantı gevşemiş olabilir\n• Faz hattı arızalı olabilir\n\nPriz veya anahtar yakmayın, hemen elektrikçi çağırın.'
      },
      {
        id: 'e3',
        question: 'Priz veya anahtardan kıvılcım çıkıyor, tehlikeli mi?',
        answer: 'EVET, ÇOK TEHLİKELİDİR! Hemen o prizi kullanmayı bırakın ve sigortadan kapatın. Kıvılcım nedenleri:\n• Gevşek bağlantı\n• Aşınmış kontaklar\n• Nem veya su teması\n• Aşırı yüklenme\n\nYangın riski vardır, acil servis çağırın.'
      },
      {
        id: 'e4',
        question: 'Topraklama neden önemli?',
        answer: 'Topraklama can güvenliğiniz için ZORUNLUDUR:\n• Elektrik çarpmasını önler\n• Cihazlarınızı korur\n• Yangın riskini azaltır\n• Yıldırım hasarını önler\n\nTopraklama olmayan evlerde kombi, çamaşır makinesi gibi cihazlar KULLANILMAMALIDIR.'
      },
      {
        id: 'e5',
        question: 'Elektrik tesisatı ne zaman yenilenmeli?',
        answer: 'Elektrik tesisatı yenileme kriterleri:\n• 25-30 yıldan eski tesisatlar\n• Alüminyum kablo kullanan tesisatlar\n• Sigortası sürekli atan tesisatlar\n• Isınan priz veya anahtarlar\n• Yanan kablo kokusu\n• Kaçak akım sorunu\n\nBunlardan biri varsa tesisat kontrolü şarttır.'
      },
    ],
    beyaz: [
      {
        id: 'b1',
        question: 'Çamaşır makinesi su almıyor, ne yapmalıyım?',
        answer: 'Çamaşır makinesinin su almaması:\n• Su musluğu kapalı olabilir\n• Su giriş hortumu kıvrık olabilir\n• Filtre tıkalı olabilir\n• Selenoid valf arızalı olabilir\n• Basınç şalteri bozuk olabilir\n\nÖnce musluğu ve hortumu kontrol edin.'
      },
      {
        id: 'b2',
        question: 'Buzdolabı sürekli çalışıyor ama soğutmuyor?',
        answer: 'Buzdolabının soğutmama nedenleri:\n• Gaz kaçağı olabilir\n• Kompresör zayıflamış olabilir\n• Termostat arızalı olabilir\n• Evaporatör buzlanmış olabilir (nofrost arızası)\n• Kapak contası bozuk olabilir\n\nSürekli çalışma elektrik faturasını da artırır.'
      },
      {
        id: 'b3',
        question: 'Bulaşık makinesi bulaşıkları temizlemiyor?',
        answer: 'Yetersiz temizlik nedenleri:\n• Spreyler tıkalı olabilir\n• Filtreler kirli olabilir\n• Su sertliği ayarsız olabilir\n• Deterjan dozajı yanlış olabilir\n• Su ısıtıcı arızalı olabilir\n\nÖnce filtreleri ve spreyleri temizleyip tekrar deneyin.'
      },
      {
        id: 'b4',
        question: 'Beyaz eşyalarda garanti süresi ne kadar?',
        answer: 'Yasal garanti süreleri:\n• Üretici garantisi: 2 yıl (zorunlu)\n• Servis garantisi: 1-2 yıl (servise göre değişir)\n\nHizmetGeliyo üzerinden yapılan tüm işlemlerde 1 yıl işçilik garantisi verilir. Değişen parçalarda marka garantisi geçerlidir.'
      },
    ],
    tesisat: [
      {
        id: 'ts1',
        question: 'Gider tıkandı, ne yapmalıyım?',
        answer: 'Gider tıkanıklığında:\n• Pompa veya açıcı tel deneyebilirsiniz\n• Karbonat + sirke karışımı kullanabilirsiniz\n• Kimyasal açıcılar son çare olmalı (boruya zarar verebilir)\n\nBu yöntemler işe yaramazsa profesyonel tıkanıklık açma gerekir. Spiral veya tazyikli su ile açılır.'
      },
      {
        id: 'ts2',
        question: 'Borulardan gelen ses normal mi?',
        answer: 'Borulardan gelen sesler:\n• Çekiç sesi: Su basıncı sorunu veya gevşek boru\n• Islık sesi: Vana veya musluk arızası\n• Fokurdama: Sistemde hava var\n• Tıkırtı: Genleşme sesleri (normal olabilir)\n\nSes sürekli ve rahatsız edici ise kontrol ettirin.'
      },
      {
        id: 'ts3',
        question: 'Su kaçağını nasıl tespit edebilirim?',
        answer: 'Su kaçağı tespiti:\n• Sayaç kontrolü: Tüm musluklar kapalıyken sayaç dönüyorsa kaçak var\n• Nem/Rutubet: Duvarda veya döşemede nem lekesi\n• Fatura artışı: Açıklanamayan su faturası artışı\n• Ses: Gece sessizliğinde su sesi\n\nKaçak tespiti için özel cihazlar kullanılır.'
      },
      {
        id: 'ts4',
        question: 'Tesisat yenileme ne zaman gerekli?',
        answer: 'Tesisat yenileme kriterleri:\n• 30 yıldan eski galvaniz borular\n• Sürekli tıkanıklık sorunu\n• Paslı veya renkli su\n• Düşük su basıncı\n• Sık sık patlak veya kaçak\n\nEski binalarda tadilat öncesi tesisat kontrolü önerilir.'
      },
    ],
    odeme: [
      {
        id: 'o1',
        question: 'Ödemeyi nasıl yapacağım?',
        answer: 'Ödeme seçenekleri:\n• Nakit: Ustaya doğrudan\n• Kredi kartı: Ustanın POS cihazı ile\n• Havale/EFT: İş tamamlandıktan sonra\n\nÖdeme işi tamamlandıktan sonra ustaya yapılır. Ön ödeme talep edilmez.'
      },
      {
        id: 'o2',
        question: 'Garanti kapsamı nedir?',
        answer: 'HizmetGeliyo garanti kapsamı:\n• 1 yıl işçilik garantisi\n• Değişen parçalarda marka garantisi\n• 30 gün memnuniyet garantisi\n• Aynı arıza tekrarında ücretsiz servis\n\nGaranti için faturanızı saklayın.'
      },
      {
        id: 'o3',
        question: 'Fatura alabilir miyim?',
        answer: 'Evet, tüm hizmetlerimiz için fatura düzenlenir. Fatura türleri:\n• Bireysel fatura\n• Kurumsal fatura\n\nFatura talebinizi talep oluştururken veya hizmet sonrasında iletebilirsiniz.'
      },
      {
        id: 'o4',
        question: 'Memnun kalmazsam ne olur?',
        answer: 'Memnuniyet garantimiz kapsamında:\n• 30 gün içinde aynı sorun tekrarlarsa ücretsiz servis\n• Haklı şikayetlerde tam iade\n• 7/24 destek hattından yardım\n\nŞikayetlerinizi 0850 242 78 08 veya info@hizmetgeliyo.com adresine iletebilirsiniz.'
      },
    ],
  };

  const filteredFAQ = Object.keys(faqData).reduce((acc, category) => {
    const filtered = faqData[category].filter(
      faq => 
        faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
        faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
    );
    if (filtered.length > 0) acc[category] = filtered;
    return acc;
  }, {});

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-28 pb-16 bg-gradient-to-br from-[#006D77] via-[#0A9396] to-[#005F69] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Sık Sorulan Sorular
            </h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto mb-8">
              Kombi servisi, klima bakımı, elektrik ve tesisat hizmetleri hakkında merak ettiğiniz her şey
            </p>
            
            {/* Search Box */}
            <div className="max-w-xl mx-auto relative">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <Input
                type="text"
                placeholder="Soru ara... (örn: kombi bakımı, klima montajı)"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-12 pr-4 py-4 h-14 text-base rounded-2xl bg-white text-gray-800 border-0 shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Quick Links */}
      <section className="py-8 bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map(cat => (
              <button
                key={cat.id}
                onClick={() => { setOpenCategory(cat.id); setSearchTerm(''); }}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all ${
                  openCategory === cat.id
                    ? `bg-gradient-to-r ${cat.color} text-white shadow-md`
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                <cat.icon className="w-4 h-4" />
                {cat.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {searchTerm ? (
            // Search Results
            <div className="space-y-6">
              <h2 className="text-xl font-bold text-gray-800 mb-4">
                "{searchTerm}" için sonuçlar ({Object.values(filteredFAQ).flat().length} sonuç)
              </h2>
              {Object.keys(filteredFAQ).length === 0 ? (
                <div className="text-center py-12 bg-white rounded-2xl shadow-sm">
                  <HelpCircle className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                  <p className="text-gray-500">Aramanızla eşleşen sonuç bulunamadı.</p>
                  <p className="text-gray-400 text-sm mt-2">Farklı kelimelerle tekrar deneyin.</p>
                </div>
              ) : (
                Object.entries(filteredFAQ).map(([category, questions]) => (
                  <div key={category} className="space-y-3">
                    <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
                      {categories.find(c => c.id === category)?.name}
                    </h3>
                    {questions.map(faq => (
                      <FAQItem key={faq.id} faq={faq} isOpen={openQuestions[faq.id]} onToggle={() => toggleQuestion(faq.id)} />
                    ))}
                  </div>
                ))
              )}
            </div>
          ) : (
            // Category View
            <div className="space-y-4">
              {faqData[openCategory]?.map(faq => (
                <FAQItem key={faq.id} faq={faq} isOpen={openQuestions[faq.id]} onToggle={() => toggleQuestion(faq.id)} />
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-[#006D77] to-[#0A9396]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">Sorunuz mu var?</h2>
          <p className="text-xl text-white/80 mb-8">
            Aradığınız cevabı bulamadıysanız bize ulaşın, yardımcı olalım.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:08502427808"
              className="flex items-center gap-2 px-6 py-3 bg-white text-[#006D77] rounded-xl font-semibold hover:bg-gray-100 transition-colors"
            >
              <Phone className="w-5 h-5" />
              0850 242 78 08
            </a>
            <a
              href="/iletisim"
              className="flex items-center gap-2 px-6 py-3 bg-white/20 text-white rounded-xl font-semibold hover:bg-white/30 transition-colors border border-white/30"
            >
              <MessageCircle className="w-5 h-5" />
              Bize Yazın
            </a>
          </div>
        </div>
      </section>

      {/* SEO Content Section */}
      <section className="py-12 bg-gray-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-gray max-w-none">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Ev Hizmetleri Rehberi</h2>
            
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <h3 className="font-bold text-lg text-gray-800 mb-3 flex items-center gap-2">
                  <Thermometer className="w-5 h-5 text-orange-500" />
                  Kombi Bakımı ve Servisi
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Kombi bakımı, enerji verimliliği ve can güvenliği için kritik öneme sahiptir. 
                  Yıllık kombi bakımı ile %30'a varan yakıt tasarrufu sağlanabilir. Profesyonel 
                  kombi servisi ile Vaillant, Bosch, Baymak, DemirDöküm ve tüm markalara hizmet veriyoruz.
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <h3 className="font-bold text-lg text-gray-800 mb-3 flex items-center gap-2">
                  <Wrench className="w-5 h-5 text-blue-500" />
                  Klima Montaj ve Bakımı
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Profesyonel klima montajı ile verimli soğutma ve ısıtma sağlayın. 
                  Split klima, inverter klima ve VRF sistem montajı yapıyoruz. 
                  Klima gazı dolumu, klima temizliği ve periyodik bakım hizmetlerimizle yanınızdayız.
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <h3 className="font-bold text-lg text-gray-800 mb-3 flex items-center gap-2">
                  <Zap className="w-5 h-5 text-yellow-500" />
                  Elektrik Tesisatı
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Elektrik arıza tespiti, priz montajı, aydınlatma sistemleri ve komple 
                  tesisat yenileme hizmetleri sunuyoruz. Sigorta değişimi, topraklama 
                  tesisatı ve kaçak akım koruma sistemleri uzman elektrikçilerimiz tarafından yapılır.
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <h3 className="font-bold text-lg text-gray-800 mb-3 flex items-center gap-2">
                  <Droplets className="w-5 h-5 text-cyan-500" />
                  Su Tesisatı
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Tıkanıklık açma, su kaçağı tespiti, musluk tamiri ve boru değişimi 
                  hizmetleri veriyoruz. Gider açma, lavabo montajı, klozet tamiri ve 
                  banyo tadilat işleriniz için 7/24 tesisatçı hizmeti sunuyoruz.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

// FAQ Item Component
const FAQItem = ({ faq, isOpen, onToggle }) => (
  <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
    <button
      onClick={onToggle}
      className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
    >
      <span className="font-medium text-gray-800 pr-4">{faq.question}</span>
      {isOpen ? (
        <ChevronUp className="w-5 h-5 text-[#006D77] flex-shrink-0" />
      ) : (
        <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" />
      )}
    </button>
    {isOpen && (
      <div className="px-6 pb-4">
        <div className="pt-2 border-t border-gray-100">
          <p className="text-gray-600 whitespace-pre-line leading-relaxed">{faq.answer}</p>
        </div>
      </div>
    )}
  </div>
);

export default SSS;
